import { useRef, useState, useEffect } from "react";
import { useApi } from "../../hooks/use-api";
import { useSingleton } from "../../hooks/use-singleton";
import {
  API_EXAM_SUBJECTS,
  apiStudentStudys,
  API_EXAM_CONTENT_CHAPTERS,
  API_EXAM_SHORT_MULTI,
  API_EXAM_LONG_MULTI,
  API_EXAM,
  API_EXAM_RANDOM_MULTI,
  apiMyAssestsExamSearch,
  API_EXAM_AI_CONCEPTS_DROPDOWN,
  API_GENERATE_VIDO_NEET,
} from "../../utils/api-routes";
import { useNavigate } from "react-router-dom";
import { ROUTE_LEARNING_ASSETS } from "../../route/neetJteRoute";
import { useNotify } from "../../hooks/use-notify";
const DURATION_OPTIONS = ["Secs", "Mins", "Hrs"];

const useHandler = () => {
  const { get, post } = useApi();
  const { toggleNotify } = useNotify();
  const { mail, user, role, board, examType } = useSingleton();
  const navigate = useNavigate();

  const STATIC_EXAM = "NEET";
  const [filteredAssets, setFilteredAssets] = useState([]);
  const [assetPopupOpen, setAssetPopupOpen] = useState(false);
  const [popupData, setPopupData] = useState({
    open: false,
    title: "",
    description: "",
    buttonText: "OK",
    assetId: null,
  });
  /* ===================== UI STATES ===================== */
  const [togglebtn, setToggleBtn] = useState(false);
  const [openDropdown, setOpenDropdown] = useState(null);
  const [selectedLanguage, setSelectedLanguage] = useState("");
  const [selectedExam, setSelectedExam] = useState("");
  const [conceptText, setConceptText] = useState({});
  const [preferredType, setPreferredType] = useState("audio");
  const [selectMode, setSelectMode] = useState("random");
  const [isLoading, setIsLoading] = useState(false);
  const [duration, setDuration] = useState("");
  const [conceptOptions, setConceptOptions] = useState([]);
  const [selectVideoSubject, setSelectVideoSubject] = useState("");
  const [classdetails, setClassDetails] = useState();

  console.log(classdetails);

  const [durationType, setDurationType] = useState(
    role === "guest" ? "Secs" : "Mins",
  );
  const [durationDropdown, setDurationDropdown] = useState(false);

  const filteredDurationOptions =
    role === "guest" ? ["Secs"] : DURATION_OPTIONS;

  useEffect(() => {
    if (role === "guest") {
      setDurationType("Secs");
    }
  }, [role]);

  // const handleDurationChange = (val) => {
  //   const onlyNums = val.replace(/[^0-9]/g, ""); // Allow only digits
  //   if (role === "guest") {
  //     if (parseInt(onlyNums) > 30) {
  //       setDuration("30");
  //       return;
  //     }
  //   }
  //   setDuration(onlyNums);
  // };

  const handleDurationChange = (val) => {
    const onlyNums = val.replace(/[^0-9]/g, "");

    if (onlyNums === "" || Number(onlyNums) < 1) {
      setDuration("");
      return;
    }

    if (role === "guest" && Number(onlyNums) > 30) {
      setDuration("30");
      return;
    }

    setDuration(onlyNums);
  };

  const languageRef = useRef();
  const subjectRef = useRef();
  const chapterRef = useRef();
  const mediumRef = useRef(null);

  /* ===================== DATA STATES ===================== */

  // 👉 ALL SUBJECT OPTIONS FROM API
  const [subjectOptions, setSubjectOptions] = useState([]);
  const [chapterOptions, setChapterOptions] = useState({});
  const [mediums, setMediums] = useState([]);

  // 👉 USER SELECTED SUBJECTS (UI ROWS)
  const [subjects, setSubjects] = useState([]);

  const [selectedSubject, setSelectedSubject] = useState(null);
  const [selectedChapter, setSelectedChapter] = useState(null);

  /* ===================== API CALLS ===================== */

  // useEffect(() => {
  //   const payload = {
  //     exam: STATIC_EXAM,
  //   };

  //   getSubjectDetails(payload);
  //   setSelectedExam(STATIC_EXAM);
  // }, []);

  const getUserStudiesDetails = async () => {
    try {
      const res = await get(apiStudentStudys(mail));
      if (res?.data?.data) {
        setClassDetails(res?.data.data);
        const payload = {
          board: board,
          clas: res.data.data.class,
        };
        getExamDetails(payload);
      }
    } catch (e) {
      console.log("Error getting study details", e);
    }
  };

  const getExamDetails = async (payload) => {
    setIsLoading(true);
    try {
      const res = await post(API_EXAM, payload);
      if (res) {
        setMediums(res?.data?.exams);
        setIsLoading(false);
      } else {
        alert(res?.message);
      }
    } catch (e) {
      setIsLoading(false);
      console.log("Error on getting Subject Details", e);
    }
  };

  const getSubjectDetails = async (payload) => {
    try {
      const res = await post(API_EXAM_SUBJECTS, payload);
      if (res?.data?.subjects) {
        setSubjectOptions(res.data.subjects); // ✅ OPTIONS ONLY
      }
    } catch (e) {
      console.log("Error getting subjects", e);
    }
  };

  const getChapterDetails = async ({ subject, exam, subjectId }) => {
    try {
      const res = await post(API_EXAM_CONTENT_CHAPTERS, { subject, exam });

      if (res?.data?.chapters) {
        setChapterOptions((prev) => ({
          ...prev,
          [subjectId]: res.data.chapters, // ✅ ONLY OPTIONS
        }));
      }
    } catch (e) {
      console.log("Error getting chapters", e);
    }
  };

  useEffect(() => {
    // reset subjects
    setSubjects([
      {
        id: Date.now(),
        name: "",
        unit: "",
        chapters: [],
        selectedChapterId: null,
      },
    ]);

    // reset concepts
    setConceptText({});

    // reset lesson
    // setSelectedLesson("");

    // reset unit
    // setSelectedUnit("");

    // reset chapter
    setSelectedChapter("");
  }, [selectMode]);

  // useEffect(() => {
  //   console.log("Subjects changed:", subjects);
  // }, [subjects]);

  useEffect(() => {
    getUserStudiesDetails();
  }, []);

  const formattedDetails = () => {
    const formattedSubjects = subjects?.reduce((acc, subject) => {
      if (!subject?.name) return acc;

      acc[subject.name] = subject?.chapters?.reduce((chapterAcc, chapter) => {
        if (!chapter?.name || !chapter?.concepts?.length) return chapterAcc;

        chapterAcc[chapter.name] = chapter?.concepts;
        return chapterAcc;
      }, {});

      return acc;
    }, {});

    return {
      mail,
      board: board,
      // clas: user?.data?.class,
      language: selectedLanguage,
      subjects: formattedSubjects,
      // video: preferredType === "video" ? true : false,
      // audio: preferredType === "audio" ? true : false,
      // video: false,
      // audio: true,
      video: preferredType === "video" ? true : false,
      exam: classdetails?.board,
    };
  };

  const generateAIContent = async () => {
    const payload = formattedDetails();
    try {
      const res = await post(API_EXAM_SHORT_MULTI, payload);
      if (res) {
        if (res?.data?.status === "ALREADY_EXISTS") {
          const assetId = res?.data?.existing_assets?.[0]?.asset_id;

          setPopupData({
            open: true,
            title: "Already Exists",
            description: res?.data?.message || "Content already generated",
            buttonText: "OK",
            assetId: assetId,
          });
        } else {
          setPopupData({
            open: true,
            title: "Hang Tight!",
            description:
              "We’re working on your content right now. You don’t have to stay on this page — we’ll send you an email once it's ready.",
            buttonText: "Go to Assets Page",
          });
        }
      }
    } catch (e) {
      console.log("ERROR IS COMES FROM GENEREATEAICONTENT API", e);
    }
  };

  const aiGenerate = () => generateAIContent();

  const formattedLongDetails = () => {
    const formattedSubjects = subjects?.reduce((acc, subject) => {
      if (!subject?.name || !subject?.chapters?.length) return acc;

      const chapterList = subject.chapters
        ?.filter((chapter) => chapter?.name)
        ?.map((chapter) => chapter.name);

      if (chapterList?.length) {
        acc[subject.name] = chapterList;
      }

      return acc;
    }, {});

    return {
      mail,
      board: board,
      // clas: user?.data?.class,
      language: selectedLanguage,
      subjects: formattedSubjects,
      // video: preferredType === "video",
      // audio: preferredType === "audio",
      video: preferredType === "video" ? true : false,
      // audio: true,
      exam: classdetails?.board,
    };
  };

  const generateAILongContent = async () => {
    const payload = formattedLongDetails();
    try {
      const res = await post(API_EXAM_LONG_MULTI, payload);
      if (res) {
        if (res?.data?.status === "ALREADY_EXISTS") {
          const assetId = res?.data?.existing_assets?.[0]?.asset_id; // ✅ FIX
          setPopupData({
            open: true,
            title: "Already Exists",
            description: res?.data?.message || "Content already generated",
            buttonText: "OK",
            assetId: assetId,
          });
        } else {
          setPopupData({
            open: true,
            title: "Hang Tight!",
            description:
              "We’re working on your content right now. You don’t have to stay on this page — we’ll send you an email as soon as it’s done. In the meantime, check out your previously generated assets",
            buttonText: "Go to Assets Page",
          });
        }
      }
    } catch (e) {
      console.log("ERROR IS COMES FROM GENERATELONGCONTENT", e);
    }
  };

  const aiLongGenerate = () => generateAILongContent();
  const myAssetsApiWithFilters = async (currentFilters) => {
    try {
      const exam =
        classdetails?.focus ||
        classdetails?.class ||
        user?.data?.focus ||
        examType ||
        "NEET";
      const res = await get(
        apiMyAssestsExamSearch(mail, currentFilters.search, exam),
      );

      return res; // ✅ IMPORTANT
    } catch (e) {
      console.log("ERROR", e);
    }
  };

  const handleExistingAssets = async (assetId) => {
    try {
      const res = await myAssetsApiWithFilters({ search: assetId });

      const assets = res?.data?.assets || [];
      setFilteredAssets(assets);

      return assets; // ✅ return
    } catch (e) {
      console.log("Error fetching assets", e);
    }
  };

  const generateAIRandomContent = async () => {
    const payload = {
      mail,
      board: board,
      // clas: user?.data?.class,
      exam: classdetails?.board,
      subject: subjects?.[0]?.name || "",
      // duration: duration,
      duration: `${duration} ${durationType}`,
      language: selectedLanguage,
      // video: preferredType === "video",
      // video: false,
      // audio: true,
      video: preferredType === "video" ? true : false,
    };

    try {
      const res = await post(API_EXAM_RANDOM_MULTI, payload);
      if (res) {
        if (res?.data?.status === "ALREADY_EXISTS") {
          const assetId = res?.data?.existing_assets?.[0]?.asset_id;

          setPopupData({
            open: true,
            title: "Already Exists",
            description: res?.data?.message || "Content already generated",
            buttonText: "OK",
            assetId: assetId,
          });
        } else {
          setPopupData({
            open: true,
            title: "Hang Tight!",
            description:
              "We’re generating your custom content. You can leave this page — we’ll notify you once it's ready.",
            buttonText: "Go to Assets Page",
          });
        }
      }
    } catch (e) {
      console.log("ERROR COMES FROM AI GENERATE RANDOM CONTENT", e);
    }
  };

  const aiRandomGenerate = () => generateAIRandomContent();

  /* ===================== SUBJECT ACTIONS ===================== */

  const addSubject = () => {
    // if (subjects.length >= 3) return;
    // if random mode → allow only 1 subject
    if (selectMode === "random" && subjects.length >= 1) {
      return;
    }

    // for other modes → allow max 3 subjects
    if (selectMode !== "random" && subjects.length >= 3) {
      return;
    }

    setSubjects((prev) => [
      ...prev,
      {
        id: Date.now(),
        name: "", // EMPTY INITIALLY
        chapters: [],
        selectedChapterId: null,
      },
    ]);
  };

  const deleteSubject = (id) => {
    setSubjects((prev) => prev.filter((s) => s.id !== id));
  };

  /* ===================== CHAPTER ACTIONS ===================== */

  const addChapters = (subjectId) => {
    setSubjects((prev) =>
      prev.map((s) => {
        if (s.id !== subjectId) return s;
        if (s.chapters.length >= 2) return s;

        return {
          ...s,
          chapters: [
            ...s.chapters,
            {
              id: Date.now(),
              name: "",
              concepts: [],
            },
          ],
        };
      }),
    );
  };

  const deleteChapter = (subjectId, chapterId) => {
    setSubjects((prev) =>
      prev.map((s) =>
        s.id === subjectId
          ? {
              ...s,
              chapters: s.chapters.filter((c) => c.id !== chapterId),
              selectedChapterId:
                s.selectedChapterId === chapterId ? null : s.selectedChapterId,
            }
          : s,
      ),
    );
  };

  /* ===================== CONCEPT ACTIONS ===================== */

  const getConceptDetails = async ({ exam, subject, chapter }) => {
    try {
      const payload = {
        exam,
        subject,
        chapter,
      };

      const res = await post(API_EXAM_AI_CONCEPTS_DROPDOWN, payload);

      if (res?.data?.concepts) {
        setConceptOptions(res.data.concepts);
      }
    } catch (e) {
      console.log("Error getting concepts", e);
    }
  };

  const addConcept = (subjectId, chapterId, concept) => {
    if (!concept?.trim()) return;

    setSubjects((prev) =>
      prev.map((s) => {
        if (s.id !== subjectId) return s;

        return {
          ...s,
          chapters: s.chapters.map((c) => {
            if (c.id !== chapterId) return c;

            const existing = c.concepts || [];

            // prevent duplicate
            if (existing.includes(concept)) return c;

            // Guest: replace existing concept (single select behavior)
            if (role === "guest") {
              return {
                ...c,
                concepts: [concept.trim()],
              };
            }

            // others: max 3 concepts
            if (existing.length >= 3) return c;

            return {
              ...c,
              concepts: [...existing, concept.trim()],
            };
          }),
        };
      }),
    );
  };

  const deleteConcept = (subjectId, chapterId, index) => {
    setSubjects((prev) =>
      prev.map((s) =>
        s.id === subjectId
          ? {
              ...s,
              chapters: s.chapters.map((c) =>
                c.id === chapterId
                  ? {
                      ...c,
                      concepts: c.concepts.filter((_, i) => i !== index),
                    }
                  : c,
              ),
            }
          : s,
      ),
    );
  };

  /* ===================== UTILS ===================== */

  useEffect(() => {
    const handleClickOutside = (e) => {
      if (languageRef.current?.contains(e.target)) return;
      setOpenDropdown(null);
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  const onToggleBtn = () => setToggleBtn((p) => !p);

  /* ===================== EXPORT ===================== */

  const onSelectSubject = ({ subjectId, subjectName }) => {
    // 1️⃣ Update subject name in UI
    setSubjects((prev) =>
      prev.map((s) =>
        s.id === subjectId ? { ...s, name: subjectName, chapters: [] } : s,
      ),
    );

    // 2️⃣ Call chapter API
    getChapterDetails({
      subject: subjectName,
      board: board,
      // clas: user?.data?.class,
      exam: classdetails?.board,
      subjectId,
    });

    // 3️⃣ Close dropdown
    setOpenDropdown(null);
  };

  const onSelectChapter = ({ subjectId, chapterName }) => {
    setSubjects((prev) =>
      prev.map((s) => {
        if (s.id !== subjectId) return s;

        // ❌ Prevent duplicate
        if (s.chapters.some((c) => c.name === chapterName)) {
          return s;
        }

        if (s.chapters.length >= 2) return s;

        return {
          ...s,
          chapters: [
            ...s.chapters,
            {
              id: Date.now(),
              name: chapterName,
              concepts: [],
            },
          ],
        };
      }),
    );

    setOpenDropdown(null);
  };

  useEffect(() => {
    if (!classdetails?.board) return;
    const payload = {
      board: board,
      // clas: classdetails?.data?.class,
      exam: classdetails?.board,
    };

    getSubjectDetails(payload);
  }, [classdetails?.board]);

  console.log("subjectOptions", subjectOptions);

  const resetForm = () => {
    setSubjects([
      {
        id: Date.now(),
        name: "",
        chapters: [],
        selectedChapterId: null,
      },
    ]);

    setChapterOptions({});
    setSelectedLanguage("");
  };

  const handleGenerate = () => {
    if (selectMode === "short") return aiGenerate();
    if (selectMode === "long") return aiLongGenerate();
    if (selectMode === "random") return aiRandomGenerate();
  };

  const isFormValid = () => {
    // ❌ common required fields
    if (!classdetails?.board || !selectedLanguage) return false;

    // ================= SHORT MODE =================
    if (selectMode === "short") {
      return (
        subjects?.length > 0 &&
        subjects.every(
          (subject) =>
            subject.name &&
            subject.chapters?.length > 0 &&
            subject.chapters.every(
              (chap) => chap.name && chap.concepts?.length > 0,
            ),
        )
      );
    }

    // ================= LONG MODE =================
    if (selectMode === "long") {
      return (
        subjects?.length > 0 &&
        subjects.every(
          (subject) =>
            subject.name &&
            subject.chapters?.length > 0 &&
            subject.chapters.every((chap) => chap.name),
        )
      );
    }

    // ================= RANDOM MODE =================
    if (selectMode === "random") {
      return (
        subjects?.[0]?.name && // only 1 subject allowed
        duration &&
        durationType
      );
    }

    return false;
  };

  const generateVideoNeet = async () => {
    if (!selectedChapter) return;
    setIsLoading(true);
    const payload = {
      mail,
      exam: classdetails?.board,
      subject: selectVideoSubject,
      chapter: selectedChapter,
      language: selectedLanguage,
    };

    try {
      const res = await post(API_GENERATE_VIDO_NEET, payload);
      if (res) {
        setPopupData({
          open: true,
          title: "Video Generation Started 🎬",
          description:
            "Your video is being generated. You’ll be notified once it's ready.",
          buttonText: "OK",
        });
      }
    } catch (e) {
      setIsLoading(false);
      console.log("ERROR COMES FROM GENERATE VIDEO CHAT API", e);
    }
  };

  const isValidVideoNeet =
    !selectVideoSubject || !selectedChapter || !selectedLanguage;

  return {
    isFormValid,
    user,
    role,
    togglebtn,
    subjects,
    subjectOptions,
    selectedSubject,
    openDropdown,
    selectedLanguage,
    conceptText,
    languageRef,
    subjectRef,
    chapterRef,
    chapterOptions,
    selectedChapter,
    preferredType,
    selectMode,
    selectedExam,
    mediums,
    mediumRef,
    isLoading,
    duration,
    subjectOptions,
    selectVideoSubject,
    classdetails,
    isValidVideoNeet,
    setSelectedSubject,
    setOpenDropdown,
    setSelectedLanguage,
    setConceptText,
    setSubjects,
    setSelectedChapter,
    setPreferredType,
    setSelectMode,
    setSelectedExam,
    setDuration,
    getChapterDetails,
    onSelectChapter,
    onSelectSubject,
    onToggleBtn,
    addSubject,
    deleteSubject,
    addChapters,
    deleteChapter,
    addConcept,
    deleteConcept,
    aiGenerate,
    resetForm,
    aiLongGenerate,
    handleGenerate,
    setSelectVideoSubject,
    board,
    durationDropdown,
    handleDurationChange,
    filteredDurationOptions,
    durationType,
    setDurationType,
    setDurationDropdown,
    DURATION_OPTIONS,
    navigate,
    popupData,
    setPopupData,
    handleExistingAssets,
    filteredAssets,
    setFilteredAssets,
    assetPopupOpen,
    setAssetPopupOpen,
    conceptOptions,
    getConceptDetails,
    generateVideoNeet,
    toggleNotify,
  };
};

export default useHandler;
